import React from 'react';
import { TitleSubtitleWrapper, ImageScrollContainer } from './styled';

const ImageCardComponent = ({ title, subtitle, images = [], theme }) => {
  return (
    <TitleSubtitleWrapper theme={theme}>
      {title && <div className="imagecard-title">{title}</div>}
      {subtitle && <div className="imagecard-subtitle">{subtitle}</div>}

      <ImageScrollContainer theme={theme}>
        {images.map((item, idx) => {
          // If item is just a string, fallback to that for url
          // Otherwise, use item.url, item.shortTitle, item.link
          const url = typeof item === 'string' ? item : item.url;
          const shortTitle = typeof item === 'object' ? item.shortTitle : '';
          const link = typeof item === 'object' ? item.link : '';

          return (
            <div className="image-wrapper" key={idx}>
              {/* The "card" with rounded corners, background, etc. */}
              <div className="image-item">
                {/* Make the image clickable by wrapping with <a> */}
                {link ? (
                  <a
                    href={link}
                    target="_blank"
                    rel="noreferrer"
                    className="image-item-link"
                  >
                    <img src={url} alt={`img-${idx}`} />
                  </a>
                ) : (
                  <img src={url} alt={`img-${idx}`} />
                )}
              </div>

              {/* Title displayed below the rounded card */}
              {shortTitle && (
                <div className="image-item-title">
                  {shortTitle}
                </div>
              )}
            </div>
          );
        })}
      </ImageScrollContainer>
    </TitleSubtitleWrapper>
  );
};

export default ImageCardComponent;
